// src/components/Dashboard/KpiCard.js
import React from 'react';
import './KpiCard.css';

/**
 * Tarjeta KPI reutilizable para el Dashboard.
 * @param {string} title - El título de la métrica (ej: "Órdenes Abiertas")
 * @param {string} value - El valor a mostrar (ej: "1,250")
 * @param {string} icon - El nombre de la clase de Bootstrap Icon (ej: "bi-file-earmark-text")
 * @param {string} color - 'blue', 'red', 'green', 'black' (para usar la paleta)
 */
const KpiCard = ({ title, value, subtitle, icon, color = 'blue', onClick, kpiKey }) => {
  
  // Determinamos si la tarjeta es clickeable
  const isClickable = !!onClick;

  const handleClick = () => {
    if (isClickable) {
      onClick(kpiKey, title); // Pasamos la "clave" y el título al hacer clic
    }
  };

  return (
    <div className="col-md-4 mb-3">
      {/* Añadimos clase 'clickable' si tiene 'onClick' */}
      <div 
        className={`kpi-card card shadow-sm ${isClickable ? 'clickable' : ''}`}
        onClick={handleClick}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div className="kpi-text">
              <h5 className="card-title text-muted">{title}</h5>
              <h2 className="kpi-value">{value}</h2>
              {subtitle && <small className="text-muted d-block">{subtitle}</small>}
            </div>
            <div className={`kpi-icon-wrapper ${color}`}>
              <i className={`bi ${icon}`}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KpiCard;